import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import styled from 'styled-components';
import { info } from './InfoPopup';
function showDeviceErrorPopup(title, content) {
    info({
        width: '25.625rem',
        noOk: true,
        children: (_jsxs(_Fragment, { children: [_jsx(Title, { children: title }), content] })),
    });
}
const Title = styled.div `
    line-height: 1.75rem;
    font-size: 1.375rem;
    font-weight: 600;
    margin-bottom: 1rem;
`;
export function showNotAllowedErrorPopup({ audio, video }) {
    if (!audio && video) {
        showDeviceErrorPopup('StreamrTV is blocked from using your camera', 'Check your camera permissions to continue.');
        return;
    }
    if (audio && !video) {
        showDeviceErrorPopup('StreamrTV is blocked from using your microphone', 'Check your microphone permissions to continue.');
        return;
    }
    showDeviceErrorPopup('StreamrTV is blocked from using your microphone and camera', 'Check your microphone and/or camera permissions to continue.');
}
export function showNoCameraFoundPopup() {
    showDeviceErrorPopup('No camera found', 'Check your system settings to make sure that a camera is available. If not, plug one in. You might then need to restart your browser.');
}
export function showNoMicrophoneFoundPopup() {
    showDeviceErrorPopup('No microphone found', 'Check your system settings to make sure that a microphone is available. If not, plug one in. You might then need to restart your browser.');
}
export function showNoCameraOrMicrophoneFound() {
    showDeviceErrorPopup(
    // biome-ignore lint/complexity/noUselessFragments: <explanation>
    _jsx(_Fragment, { children: "Check your microphone and\u00A0camera" }), "Check your system settings to confirm your camera and microphone are connected. If they're not, please plug them in.");
}
